'use client'

// Must be first import to suppress console output before anything else loads
import '@/utils/console-suppressor'

import { ChapterMenu } from '@/components/Chapter'
import Credits from '@/components/Credits'
import { ConsoleOverride } from '@/components/Debug/Logger'
import FooterBar from '@/components/FooterBar'
import Landing from '@/components/Landing'
import Navbar from '@/components/Navbar'
import { PreloaderIndicator } from '@/components/PreloaderIndicator'
import { SubtitleDisplay } from '@/components/Subtitles'
import AudioElement from '@/components/XR/AudioElement'
import XRCanvas from '@/components/XR/XRCanvas'
import { useAudio } from '@/context/AudioContext'
import { useNavigation } from '@/context/NavigationContext'
import { useUserPrefs } from '@/context/UserPrefsContext'
import { useVideo } from '@/context/VideoContext'
import { useEffect, useState } from 'react'

export default function Page() {
  // Use navigation context to manage view state
  const { view, setView } = useNavigation()
  const { pause: pauseVideo } = useVideo()
  const { pause: pauseAudio } = useAudio()
  const { userPrefs } = useUserPrefs()
  const [xrAnimation, setXrAnimation] = useState<'fade-in' | ''>('')
  const [showCredits, setShowCredits] = useState(false)

  useEffect(() => {
    if (view === 'credits') {
      pauseAudio()
      pauseVideo()
    }
  }, [view, pauseAudio, pauseVideo])

  const handleBackHome = () => {
    setShowCredits(false)
    setView('landing')
  }

  return (
    <>
      <AudioElement />
      <ConsoleOverride />
      <PreloaderIndicator />
      {view === 'landing' && <Landing />}

      {view === 'xr' && (
        <section className={`${xrAnimation}`}>
          <Navbar />
          <ChapterMenu />
          <XRCanvas />
          <SubtitleDisplay />
          <FooterBar />
        </section>
      )}

      {view === 'credits' && <Credits onBackHome={handleBackHome} />}
    </>
  )
}
